import { useMemo } from "react";
import { MutationsObject, QueriesObject } from "./useUserLoading";

export const useUserError = (
  queries: QueriesObject,
  mutations: MutationsObject,
) => {
  return useMemo(() => {
    const queryError = queries.userQuery.error;
    const mutationError =
      mutations.activateUserMutation.error ||
      mutations.deactivateUserMutation.error ||
      mutations.updateUserMutation.error ||
      mutations.createUserMutation.error;

    const error = queryError || mutationError;
    const isQuery = !!queryError;

    return { error, isQuery };
  }, [
    queries.userQuery.error,
    mutations.activateUserMutation.error,
    mutations.deactivateUserMutation.error,
    mutations.updateUserMutation.error,
    mutations.createUserMutation.error,
  ]);
};
